import React from 'react';
import styled from 'styled-components/macro';
/**
 *  Lista de checkbox que permite elegir entre varias opciones. Se utiliza en la pantalla
 * de estadísitcas para elegir entre distintos tipos de estadísticas.
 */

const CheckboxList = ({ atts, vars,elec }) => {
  const Boton = ({ tipo1, tipo2, title, color }) => {
    return (
      <button
        onClick={() => {
          vars.funs[0](tipo1);
          vars.funs[1](tipo2);
        }}
        disabled={elec === "7" && tipo2 === "VP"}
      >
        {vars.vars[0] === tipo1 && vars.vars[1] === tipo2 ? (
          <Seleccion color={color} />
        ) : (
          <Circulo color={color} />
        )}
        <span>{title}</span>
      </button>
    );
  };

  return (
    <section css="padding-left: 20px;">
      <SH3>{atts.titulo}</SH3>
      {atts.lista.map(x => {
        return (
          <Lista color={atts.color}>
            <h4>{x.titulo}</h4>
            {x.lista.map((y, i) => {
              return (
                <div key={i}>
                  <Boton
                    tipo1={x.tipo}
                    tipo2={y.tipo}
                    title={y.nombre}
                    color={atts.color}
                  />
                </div>
              );
            })}
          </Lista>
        );
      })}
    </section>
  );
};

export default CheckboxList;

const SH3 = styled.h3`
  font-size: 1.6rem;
  font-weight: bold;
  margin-top: 98px;
  margin-left: 7rem;
  text-transform: uppercase;
  color: #fff;
`;

const Lista = styled.article`
  margin-left: 7rem;
  margin-top: 2em;
  & h4 {
    font-size: 1.4rem;
    font-weight: 900;
    color: #fff;
    text-transform: uppercase;
  }
  & > div {
    margin: 1em 0;
    :hover {
      font-weight: bold;
    }
  }
  & > div > button {
    background: none;
    display: flex;
    &:disabled {
      div{
      background-color: #4f76b1;
      border-color: #4f76b1;
    }
  }
  }
  & > div > button > div {
    margin-right: 0.5em;
    margin-top: 0.15em;
  }
  & > div > button > span {
    font-size: 1.4rem;
    color: #fff;
  }
  & > div > button {
    &:disabled {
      div, span {
        color: #4f76b1;
      }
    }
  }
`;

const Circulo = styled.div`
  border: 2px solid;
  border-color: #fff;
  height: 16px;
  width: 16px;
  border-radius: 20px;
  background-color: #fff;
`;

const CirculoLleno = styled.div`
  border: 2px solid;
  border-color: #00f7f0;
  height: 16px;
  width: 16px;
  border-radius: 20px;
  background: #00f7f0;
`;

const CirculoInterior = styled.div`
  height: 8px;
  width: 8px;
  border-radius: 10px;
  background-color: #fff;
  margin: 4px 0 0 4px;
`;

const Seleccion = ({ color }) => (
  <CirculoLleno color={color}>
    <CirculoInterior />
  </CirculoLleno>
);
